import { Observable } from 'rxjs';
import { Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService, PaginatedResponse } from '@tcc-mono/shared/data-access';
import { Relation, Stable } from '@tcc-mono/vandijk/shared/data-access/models';

@Injectable({
  providedIn: 'root'
})
export class RelationService extends BaseService<Relation> {
  public constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/relations'
  }

  public getStables = (relationId: string | number, params?: Params) => {
    return this.getChild(relationId, 'stables', params) as Observable<PaginatedResponse<Stable>>;
  }

  public getKVSPassword = (relationId: string | number, params?: Params) => {
    return this.getChild(relationId, 'kvspassword', params) as Observable<{password:string}>;
  }

  public getLoadingUbns(
    relationId: string | number,
    period: 'year' | 'all' = 'year',
  ): Observable<RelationLoadingUbnsResponse> {
    return this.getChild(relationId, 'loading-ubns', { period }) as Observable<RelationLoadingUbnsResponse>;
  }
}

export type RelationLoadingUbnPeriod = 'year' | 'all';

export interface RelationLoadingUbn {
  loading_ubn: string;
  animals_count: number;
  rides_count: number;
  last_loaded_at: string | null;
}

export interface RelationLoadingUbnsResponse {
  relation_id: number;
  period: RelationLoadingUbnPeriod;
  period_from: string | null;
  data: RelationLoadingUbn[];
}
